// src/features/events/eventSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Thunk: fetch events (upcoming or past)
export const fetchEvents = createAsyncThunk(
  "events/fetchEvents",
  async (eventType, { rejectWithValue }) => {
    try {
      const res = await agent.get(`${API.LOAD_EVENT}/${eventType}`);
      return res.data.data; // API returns events in data.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Thunk: RSVP submission
export const submitRSVP = createAsyncThunk(
  "events/submitRSVP",
  async ({ data, setShow, setLoader }, { rejectWithValue }) => {
    try {
      const res = await agent.post(API.SUBMIT_RSVP, data);
      if (res.status === 200) {
        setShow(false);
        setLoader(false);
      }
      return res.data;
    } catch (err) {
      setLoader(false);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const eventSlice = createSlice({
  name: "events",
  initialState: {
    events: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetEvents: (state) => {
      state.events = [];
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Events
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload || [];
      })
      .addCase(fetchEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // RSVP
      .addCase(submitRSVP.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitRSVP.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(submitRSVP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default eventSlice.reducer;
